import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="28" cy="28" r="28" fill="#EBEBEB" /><mask id="a" style={{
    maskType: "alpha"
  }} maskUnits="userSpaceOnUse" x="7" y="8" width="42" height="43"><circle cx="28" cy="29.167" r="21" fill="#fff" /></mask><g mask="url(#a)" fill="#fff"><rect x="10.5" y="32.667" width="35" height="17.5" rx="7" /><circle cx="28" cy="18.667" r="10.5" /></g></svg>);